var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    !_vm.load_first ? _c("div", [_c("jLoadingTable")], 1) : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.load_first,
            expression: "load_first"
          }
        ]
      },
      [
        _c(
          "v-server-table",
          {
            ref: "flowServer",
            staticClass: "jTable",
            attrs: { url: _vm.env, columns: _vm.columns, options: _vm.options },
            on: {
              loading: _vm.loading,
              loaded: _vm.loaded,
              "row-click": _vm.rowClick,
              pagination: _vm.removeRowBackground
            },
            scopedSlots: _vm._u([
              {
                key: "sla_policy",
                fn: function(props) {
                  return _c(
                    "div",
                    {},
                    _vm._l(props.row.sla, function(policy) {
                      return _c("div", { key: policy.id }, [
                        _vm._v(
                          "\n          Type " +
                            _vm._s(policy.type - 1) +
                            " value (" +
                            _vm._s(policy.value) +
                            "%)\n        "
                        )
                      ])
                    })
                  )
                }
              }
            ])
          },
          [
            _c(
              "div",
              {
                staticClass: "custom-search",
                attrs: { slot: "beforeFilter" },
                slot: "beforeFilter"
              },
              [
                _c(
                  "b-form",
                  {
                    attrs: { inline: "" },
                    on: {
                      keypress: function($event) {
                        if (!("button" in $event) && $event.keyCode !== 13) {
                          return null
                        }
                        $event.preventDefault()
                        _vm.filter(_vm.filter_data)
                      }
                    }
                  },
                  [
                    _c("j-select", {
                      staticClass: "m__r--5",
                      attrs: { disabled: false, options: _vm.options_search },
                      model: {
                        value: _vm.select_type,
                        callback: function($$v) {
                          _vm.select_type = $$v
                        },
                        expression: "select_type"
                      }
                    }),
                    _vm._v(" "),
                    _c("b-form-input", {
                      ref: "filterInput",
                      staticClass: "m__r--5",
                      attrs: { placeholder: "search" },
                      model: {
                        value: _vm.filter_data,
                        callback: function($$v) {
                          _vm.filter_data = $$v
                        },
                        expression: "filter_data"
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "b-button",
                      {
                        staticClass: "btn grey btn-import-form",
                        on: {
                          click: function($event) {
                            _vm.filter(_vm.filter_data)
                          }
                        }
                      },
                      [
                        _c("i", { staticClass: "fa fa-search bold" }),
                        _vm._v(" Search\n          ")
                      ]
                    )
                  ],
                  1
                )
              ],
              1
            )
          ]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-fa4a51c0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fa4a51c0","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/flow-rule/flow/flow-sla/list/jListFlowSLA.vue
// module id = null
// module chunks = 